module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ActivityView.js"));
	}, "ActivityView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ActivityView!./src/pages/Shop/Home/Carnival/20230818/ActivityView.js
// module id = 1855
// module chunks = 367